import { Field } from "../Models/Field";
import { SelectControl } from "./index";
import { FieldType } from "../Enum/FieldType";
import Control from "./Control";
import { Utils } from "../Utils/Utils";
export default class DateControl extends Control {
    constructor(field) {
        super(field);
        this.daysSelectControl = null;
        this.monthSelectControl = null;
        this.yearSelectControl = null;
        this.initialYear = null;
        this.initialMonth = null;
        this.initialDay = null;
        this.startYear = new Date().getFullYear() - 60;
        this.endYear = new Date().getFullYear() + 10;
        //TODO: get this from field setting from json
        if (this.field.displayName.toLowerCase().startsWith("availability date")) {
            this.startYear = new Date().getFullYear();
        }
        if (this.field.displayName.toLowerCase().startsWith("date of birth")) {
            this.startYear = new Date().getFullYear() - 80;
            this.endYear = new Date().getFullYear() - 18;
        }
    }
    renderField() {
        if (this.initialValue) {
            const initialDate = new Date(this.initialValue);
            const offsetDate = new Date(initialDate.getTime() - initialDate.getTimezoneOffset() * -60000); // Remove the timezone offset in order to get from the saved date regarding the timezone
            this.initialYear = { valueId: offsetDate.getFullYear().toString() };
            this.initialMonth = { valueId: offsetDate.getMonth().toString() };
            this.initialDay = { valueId: offsetDate.getDate().toString() };
        }
        return `<div class=date-control data-main id="${this.field.internalId}">${this.renderYears()}<span>/</span>${this.renderMonths()}<span>/</span>${this.renderDays()}</div>`;
    }
    renderPreview() {
        return `<span>${Utils.isOk(this.initialValue)
            ? new Date(this.initialValue).toLocaleDateString()
            : ""}</span>`;
    }
    renderDays() {
        const field = new Field();
        field.internalId = this.field.internalId + "-days";
        field.fieldType = FieldType.Selection;
        field.selectionFieldSettings = {
            options: [],
            listOfValuesId: null,
            allowCustomValue: null,
        };
        field.placeHolder = "- Day -";
        this.daysSelectControl = new SelectControl(field, false);
        this.daysSelectControl.initialValue = this.initialDay;
        return this.daysSelectControl.render();
    }
    renderMonths() {
        const monthNames = Array.from({ length: 12 }, (_, monthIndex) => {
            const date = new Date(2000, monthIndex, 1);
            return date.toLocaleString("en-US", { month: "long" });
        });
        const field = new Field();
        field.internalId = this.field.internalId + "-month";
        field.fieldType = FieldType.Selection;
        field.selectionFieldSettings = {
            options: [],
            listOfValuesId: null,
            allowCustomValue: null,
        };
        field.placeHolder = "- Month -";
        for (let i = 0; i < monthNames.length; i++) {
            field.selectionFieldSettings.options.push({
                optionId: (i).toString(),
                optionValue: monthNames[i],
                isDescendentRequired: false
            });
        }
        this.monthSelectControl = new SelectControl(field, false);
        this.monthSelectControl.initialValue = this.initialMonth;
        return this.monthSelectControl.render();
    }
    renderYears() {
        const field = new Field();
        field.internalId = this.field.internalId + "-year";
        field.fieldType = FieldType.Selection;
        field.selectionFieldSettings = {
            options: [],
            listOfValuesId: null,
            allowCustomValue: null,
        };
        field.placeHolder = "- Year -";
        for (let i = this.endYear; i >= this.startYear; i--) {
            field.selectionFieldSettings.options.push({
                optionId: i.toString(),
                optionValue: i.toString(),
                isDescendentRequired: false
            });
        }
        this.yearSelectControl = new SelectControl(field, false);
        this.yearSelectControl.initialValue = this.initialYear;
        return this.yearSelectControl.render();
    }
    getDateValue() {
        var _a, _b, _c;
        const day = (_a = ((document.getElementById(this.field.internalId + "-days_select")))) === null || _a === void 0 ? void 0 : _a.value;
        const month = (_b = ((document.getElementById(this.field.internalId + "-month_select")))) === null || _b === void 0 ? void 0 : _b.value;
        const year = (_c = ((document.getElementById(this.field.internalId + "-year_select")))) === null || _c === void 0 ? void 0 : _c.value;
        if (day !== "" && month !== "" && year !== "") {
            return new Date(Date.UTC(parseInt(year), parseInt(month), parseInt(day)));
        }
        return null;
    }
    getValue() {
        const dateValue = this.getDateValue();
        if (dateValue) {
            let ret = JSON.stringify(dateValue);
            if (ret.length >= 2 && ret[0] === '"' && ret[ret.length - 1] === '"') {
                ret = ret.substring(1, ret.length - 1);
            }
            return ret;
        }
        return "";
    }
    afterRender() {
        super.afterRender();
        if (!this.monthSelectControl || !this.yearSelectControl) {
            return;
        }
        this.updateDayOptions();
        let self = this;
        this.monthSelectControl.getInputElement().onchange = function () {
            self.updateDayOptions();
        };
        this.yearSelectControl.getInputElement().onchange = function () {
            self.updateDayOptions();
        };
    }
    /**
     * Update day options based on the selected month and year(to take leap year into consideration)
     */
    updateDayOptions() {
        const month = (document.getElementById(`${this.field.internalId}-month_select`)).value;
        const year = (document.getElementById(`${this.field.internalId}-year_select`)).value;
        if (month !== "" && year !== "") {
            const monthVal = parseInt(month);
            const yearVal = parseInt(year);
            // Get number of days based on the month and year
            const daysInMonth = new Date(yearVal, monthVal + 1, 0).getDate();
            let options = [];
            for (let i = 1; i <= daysInMonth; i++) {
                options.push({
                    optionId: i.toString(),
                    optionValue: i.toString(),
                    isDescendentRequired: false
                });
            }
            this.daysSelectControl.updateOptions(options, "- Day -");
        }
    }
}
